import { render, staticRenderFns } from "./WorkerEdit.vue?vue&type=template&id=19adaa68&"
import script from "./WorkerEdit.vue?vue&type=script&lang=js&"
export * from "./WorkerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports